export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_th.3437d04f5056a409.json"